type Props = {
  children: React.ReactNode;
};

export const ListItem = ({ children }: Props): JSX.Element => (
  <li className="m-0 font-cera text-[16px] font-normal leading-5 tracking-[-0.22px]">
    <span className="text-purple">&mdash; </span>
    {children}
  </li>
);

export const ListItemFAQs = ({ children }: Props): JSX.Element => (
  <li className="m-0 font-cera text-[14px] font-normal leading-[17px] tracking-[-0.22px] lg:leading-[20px]">
    <span className="text-purple">&mdash; </span>
    {children}
  </li>
);
